import { render } from "./Disciplines.vue?vue&type=template&id=6794c96c"
import script from "./Disciplines.vue?vue&type=script&lang=js"
export * from "./Disciplines.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__